import { render } from "./Step7Component.vue?vue&type=template&id=6a37765c"
import script from "./Step7Component.vue?vue&type=script&lang=js"
export * from "./Step7Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__